import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';
import { AlbertaHero } from './components/AlbertaHero';
import { ProvincialOverview } from './components/ProvincialOverview';
import { EdmontonRules } from './components/EdmontonRules';
import { EdmontonEnforcement } from './components/EdmontonEnforcement';
import { CalgaryRules } from './components/CalgaryRules';
import { CalgaryEnforcement } from './components/CalgaryEnforcement';
import { CityComparison } from './components/CityComparison';
import { AlbertaCTA } from './components/AlbertaCTA';

export default function AlbertaSTR() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <AlbertaHero />
      <ProvincialOverview />
      <EdmontonRules />
      <EdmontonEnforcement />
      <CalgaryRules />
      <CalgaryEnforcement />
      <CityComparison />
      <AlbertaCTA />
      <Footer />
    </div>
  );
}
